import React, { useState, useEffect } from 'react'

import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
  DatePicker,
  Icon,
  message,
  Checkbox
} from 'antd'

import HeroModal from './components/HeroModal'
import HeroLocations from './components/HeroLocations'
import HeroAddress from './components/HeroAddress'
import HeroDocument from './components/HeroDocument'
import HeroTruck from './components/HeroTruck'
import HeroBankAccount from './components/HeroBankAccount'
import { HeroType } from '../../config'
import { ENDPOINT } from '../../utils/constants'
import {
  updateHeroStatus,
  getHeroLocationList,
  getAllHeroes,
  getHeroConfigs,
  getHeroTypeSize,
  getHeroStatusSize,
  saveQrCodeHero
} from '../../modules/hero'
import { fetchDocumentPendingByHeroId } from '../../modules/document'
import { updateCoinAllHero } from '../../modules/coin'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { HERO_TYPE, STATUS } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import QrCodeModal from './components/QrCodeModal'
import UpdateCoinAllHero from './components/UpdateCoinAllHero'
import UpdateStatus from './components/UpdateStatus'
import LogContract from './components/LogContract'
import moment from 'moment'
import Lightbox from 'react-image-lightbox'
import '../../../node_modules/react-image-lightbox/style.css'
import axios from 'axios'
import 'moment/locale/th'
import locale from 'antd/es/date-picker/locale/th_TH'
import NotificationCenterModal from './components/NotiCenterModal'

import { createNotificationCenter } from '../../modules/notification'

const GetStatusColor = (status) => {
  let color = ''
  if (status !== null) {
    switch (status.toUpperCase()) {
      case 'REGISTERED':
        color = 'gold'
        break
      case 'PENDING':
        color = 'cyan'
        break
      case 'APPROVED':
        color = 'green'
        break
      case 'SUSPENDED':
        color = 'red'
        break
      case 'DISABLED':
        color = 'volcano'
        break
      case 'DELETED':
        color = 'purple'
        break
      default:
        break
    }
  }
  return color
}

const initialOptions = {
  page: 0,
  size: 20,
  heroType: '',
  status: '',
  createdAt: '',
  id: 0,
  isLoma: false
}

const initialOptionsHeroTypeSize = {
  isLoma: false
}

const Heroes = ({ form }) => {
  const { validateFields, getFieldDecorator } = form
  const dispatch = useDispatch()
  const [qrCode, setQrCode] = useState({})
  const [formData, setFormData] = useState({})
  const [selectedRowKeys, setSelectedRowKeys] = useState(() => {
    const savedKeys = localStorage.getItem('selectedRowKeys')
    return savedKeys ? JSON.parse(savedKeys) : []
  })
  const [visible, setVisible] = useState(false)
  const [visibleQR, setVisibleQR] = useState(false)
  const [visibleCoin, setVisibleCoin] = useState(false)
  const [visibleStatus, setVisibleStatus] = useState(false)
  const [visibleLogContract, setVisibleLogContract] = useState(false)
  const [filterOption, setFilterOption] = useState(initialOptions)
  const [filterOptionHeroTypeSize, setFilterOptionHeroTypeSize] = useState(initialOptionsHeroTypeSize)
  const [current, setCurrent] = useState('')
  const [visibleNotiCenter, setVisibleNotiCenter] = useState(false)
  const [value, setValue] = useState()
  const [showAppLOMA, setShowAppLOMA] = useState(false)

  useEffect(() => {
    localStorage.setItem('selectedRowKeys', JSON.stringify(selectedRowKeys))
  }, [selectedRowKeys])

  const {
    locationList,
    heroList,
    heroTypeSize,
    heroStatusSize,
    heroConfigList,
    heroDocumentPending,
    isLoading,
    isLoadingNoti
  } = useSelector(
    (state) => ({
      locationList: state.hero.locationList,
      heroList: state.hero.heroList,
      heroTypeSize: state.hero.heroTypeSize,
      heroStatusSize: state.hero.heroStatusSize,
      heroConfigList: state.hero.heroConfigList,
      heroDocumentPending: state.document.heroDocumentPending,
      isLoading: state.hero.isLoading,
      isLoadingNoti: state.notification.isLoadingNoti
    }),
    []
  )

  async function fetch() {
    await dispatch(getHeroConfigs())
    await dispatch(getHeroLocationList())
    await dispatch(getAllHeroes(filterOption))
    await dispatch(getHeroTypeSize())
    await dispatch(getHeroStatusSize())
    await dispatch(fetchDocumentPendingByHeroId())
  }

  useDeepEffect(() => {
    setShowAppLOMA(false)
    fetch()
    const params = new URLSearchParams(window.location.search)
    const id = params.get('id')
    if (id) {
      filterOption.id = id
      dispatch(getAllHeroes(filterOption))
    }
  }, [])

  async function onOk() {
    await dispatch(getAllHeroes(filterOption))
    await setVisible(false)
  }

  async function onClose() {
    await setFormData({})
    await setVisible(false)
  }

  async function onDelete(id) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    const res = await axios.delete(
      `${process.env.REACT_APP_API_ENDPOINT}/hero/hero/${id}`,
      {
        headers: {
          Authorization: authorizationHeader
        }
      }
    )
    if (!res.data.delete) {
      message.error(res.data.message)
    } else {
      await dispatch(getAllHeroes(filterOption))
      message.success(res.data.message)
    }
  }

  async function onClick(e, record) {
    e.preventDefault()
    await setFormData(record)
    await setVisible(true)
  }

  async function viewQrCode(e, record) {
    e.preventDefault()
    await setQrCode(record)
    await setVisibleQR(true)
  }

  async function onCloseViewQr(e) {
    e.preventDefault()
    await setQrCode({})
    await setVisibleQR(false)
  }

  const onClickCoin = () => {
    setVisibleCoin(true)
  }

  const onClickNotification = () => {
    setVisibleNotiCenter(true)
  }

  async function onClearSelect() {
    setSelectedRowKeys([])
  }

  const onCloseModalCoin = async () => {
    await setVisibleCoin(false)
    await fetch()
  }

  const onCloseNotiCenter = async () => {
    await setVisibleNotiCenter(false)
  }

  const onOkCoin = async (data) => {
    await dispatch(updateCoinAllHero(data))
    await setVisibleCoin(false)
    await fetch()
  }

  const onOkNotiCenter = async (data) => {
    await dispatch(createNotificationCenter(data))
    await onClearSelect()
    await setVisibleNotiCenter(false)
    await fetch()
  }

  const onChangeRadio = (e) => {
    setValue(e.target.value)
  }

  const onClickStatus = (e, record) => {
    e.preventDefault()
    setFormData(record)
    setVisibleStatus(true)
  }

  const onCloseModalStatus = async () => {
    await setVisibleStatus(false)
    await fetch()
  }

  const onOkStatus = async (data) => {
    await dispatch(updateHeroStatus(data))
    await fetch()
    await setVisibleStatus(false)
    await setFormData({})
  }

  const onClickLogContract = (e, record) => {
    e.preventDefault()
    setFormData(record)
    setVisibleLogContract(true)
  }

  const onCloseModalLogContract = async () => {
    await setVisibleLogContract(false)
  }

  async function saveQrCode() {
    if (!isEmpty(selectedRowKeys)) {
      const arr = []
      for (const id of selectedRowKeys) {
        for (const hero of heroList.content) {
          if (hero.qrCode === null) {
            if (hero.id === id) {
              arr.push(id)
            }
          }
        }
      }

      await dispatch(
        saveQrCodeHero({
          heroIds: arr
        })
      )
      await dispatch(getAllHeroes(filterOption))
    } else {
      notification.warning({
        message: 'เลือกฮีโร่อย่างน้อย 1 ฮีโร่'
      })
    }
  }

  const handleClickImage = (e, image) => {
    e && e.preventDefault()
    setCurrent(image)
  }

  const handleCloseModal = (e) => {
    e && e.preventDefault()
    setCurrent('')
  }

  const renderIdPending = (id) => {
    let status = ''
    for (const hero of heroDocumentPending) {
      if (id === hero.heroId) {
        status = 'PENDING'
      }
    }
    return status
  }
  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).format('DD/MM/YYYY')
    }
    return date
  }

  const countRenderIdPending = () => {
    let count = 0
    for (const hero of heroDocumentPending) {
      if ((hero.status = 'PENDING')) {
        count = count + 1
      }
    }
    return count
  }
  const countAllHeroTypeSize = () => {
    let count = 0
    for (const hero of heroTypeSize) {
      count = count + hero.size
    }
    return count
  }

  const countAllHeroStatusSize = () => {
    let count = 0
    for (const hero of heroStatusSize) {
      count = count + hero.size
    }
    return count
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: 'วันที่สมัคร',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 120,
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return <span>{created}</span>
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroType',
      key: 'heroType',
      width: 130,
      render: (name, row) => {
        return <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
      }
    },
    {
      title: 'Circular Hero Name',
      dataIndex: 'name',
      key: 'name',
      width: 220,
      render: (name, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <div>
              <Avatar
                src={record.imageUrl}
                onClick={(e) => handleClickImage(e, record.imageUrl)}
              />
              {current && (
                <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
              )}
            </div>
          </Col>
          <Col>
            <span>{name}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'Province',
      dataIndex: 'province',
      key: 'province',
      width: 130
    },
    {
      title: 'Telephone',
      dataIndex: 'tel',
      key: 'telephone',
      width: 130
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      filters: STATUS.map((status) => ({
        text: status,
        value: status
      })),
      onFilter: (value, record) => record.status === value,
      render: (status, record) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag
              color={color}
              key={status}
              onClick={(e) => onClickStatus(e, record)}>
              <a>
                {status} &nbsp; <Icon type="edit" />
              </a>
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'QR Code',
      dataIndex: 'qrCode',
      key: 'qrCode',
      width: 80,
      render: (text, record) => (
        <a onClick={(e) => viewQrCode(e, record)}>View</a>
      )
    },
    {
      title: 'คู่ค้า',
      dataIndex: 'countFollowingHero',
      key: 'FollowingHero',
      width: 80
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'countFollowerHero',
      key: 'FollowerHero',
      width: 80
    },
    {
      title: 'Open',
      dataIndex: 'active',
      key: 'active',
      width: 80,
      render: (text) => <div>{text ? 'เปิด' : 'ปิด'}</div>
    },
    {
      title: 'Document Status',
      dataIndex: 'id',
      key: 'id',
      width: 120,
      filters: [
        {
          text: 'PENDING',
          value: 'PENDING'
        }
      ],
      onFilter: (value, record) => {
        const status = renderIdPending(record.id)
        return status === value
      },
      render: (id) => {
        const status = renderIdPending(id)
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
          <Divider type="vertical" />
          <Button
            style={{ background: 'purple', color: 'white' }}
            size="small"
            shape="circle"
            icon="phone"
            onClick={(e) => onClickLogContract(e, record)}
          />
        </span>
      )
    }
  ]

  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  if (showAppLOMA) {
    filterOption.isLoma = true
    filterOptionHeroTypeSize.isLoma = true
  } else {
    filterOption.isLoma = false
    filterOptionHeroTypeSize.isLoma = false
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.heroType === 'all') {
          filterOption.heroType = ''
        } else {
          filterOption.heroType = values.heroType
        }

        if (values.status === 'all') {
          filterOption.status = ''
        } else {
          filterOption.status = values.status
        }

        if (values.keyword) {
          filterOption.keyword = '%' + values.keyword + '%'
        } else {
          filterOption.keyword = ''
        }

        if (values.createdAt) {
          const date = moment(values.createdAt).format('yyyy-MM-DD')
          filterOption.createdAt = date
        } else {
          filterOption.createdAt = ''
        }

        filterOption.page = 0
        await dispatch(getAllHeroes(filterOption))
        await dispatch(getHeroTypeSize(filterOptionHeroTypeSize))
        await dispatch(getHeroStatusSize(filterOptionHeroTypeSize))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.heroType = ''
    filterOption.status = ''
    filterOption.keyword = ''
    filterOption.id = 0
    form.resetFields()
    filterOption.isLoma = false
    filterOptionHeroTypeSize.isLoma = false
    setShowAppLOMA(false)
  
    await dispatch(getAllHeroes(filterOption))
    await dispatch(getHeroTypeSize(filterOptionHeroTypeSize))
    await dispatch(getHeroStatusSize(filterOptionHeroTypeSize))
  }

  function getCreatedAt() {
    const createdAt = form.getFieldValue('createdAt')
    if (createdAt != undefined) {
      const date = moment(createdAt).format('yyyy-MM-DD')
      return `&createdAt=${date}`
    }
    return ''
  }

  function getKeyword() {
    const keyword = form.getFieldValue('keyword')
    if (keyword != undefined) {
      return `&keyword=${'%' + keyword + '%'}`
    }
    return ''
  }

  function getStatus() {
    const status = form.getFieldValue('status')
    if (status != undefined && status != 'all') {
      return `&status=${status}`
    }
    return ''
  }
  function getHeroType() {
    const heroType = form.getFieldValue('heroType')
    if ((heroType != undefined) & (heroType != 'all')) {
      return `&heroType=${heroType}`
    }
    return ''
  }

  const rowSelection = {
    onChange: (newSelectedRowKeys, newSelectedRows) => {
      const newSelectedRowIds = new Set(newSelectedRowKeys)

      const updatedSelectedRowKeys = selectedRowKeys.filter((row) =>
        newSelectedRowIds.has(row.id)
      )

      newSelectedRows.forEach((row) => {
        if (
          !updatedSelectedRowKeys.find(
            (selectedRow) => selectedRow.id === row.id
          )
        ) {
          updatedSelectedRowKeys.push({
            id: row.id,
            name: row.name,
            imageUrl: row.imageUrl
          })
        }
      })

      setSelectedRowKeys(updatedSelectedRowKeys)
    },
    selectedRowKeys: selectedRowKeys.map((row) => row.id)
  }

  const hasSelected = selectedRowKeys.length > 0

  const onChangeShowLOMA = (e) => {
    setShowAppLOMA(e.target.checked)
  }

  return (
    <div>
      {!visible ? (
        <Card
          title="Heroes"
          extra={
            <div>
              <Button size="small" icon="plus" onClick={() => onClickCoin()}>
                Coin
              </Button>
              &nbsp;
              <Button size="small" icon="plus" onClick={() => setVisible(true)}>
                New Hero
              </Button>
              &nbsp;
              <Button size="small" icon="reload" onClick={() => fetch()}>
                Reload
              </Button>
            </div>
          }>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="Heroes Manager" key="1">
              <Row type="flex" justify="end" align="middle">
                <Col>
                  <Button
                    style={{ background: 'green', borderColor: '#ffffff' }}
                    type="primary">
                    <a
                      href={
                        ENDPOINT +
                        `/hero/export-hero-data?${getCreatedAt()}${getKeyword()}${getStatus()}${getHeroType()}`
                      }
                      download>
                      Export Data
                    </a>
                  </Button>
                </Col>
              </Row>
              <br></br>
              <Form onSubmit={onSubmit} layout="inline">
                <Row type="flex" justify="start" align="middle">
                  {/* <Col>
                    <Button type="primary" onClick={() => saveQrCode()}>
                      Save QR Code
                    </Button>
                  </Col> */}
                  <Col>
                    <Row type="flex" justify="end" gutter={8} align="middle">
                      <Col>
                        <Form.Item style={{ margin: 0 }} label="วันที่สมัคร">
                          {getFieldDecorator(`createdAt`)(
                            <DatePicker
                              format="DD/MM/YYYY"
                              style={{ width: 170 }}
                              locale={locale}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item style={{ margin: 0 }} label="keyword">
                          {getFieldDecorator(`keyword`)(
                            <Input
                              style={{ width: 200 }}
                              placeholder="Email,Name,Tel,Province"
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item style={{ margin: 0 }} label="สถานะ">
                          {getFieldDecorator(`status`, {
                            initialValue: 'all'
                          })(
                            <Select style={{ width: 180 }}>
                              <Select.Option value="all">
                                ทั้งหมด &nbsp;
                                <Tag color="#FF33D4">
                                  {countAllHeroStatusSize()}
                                </Tag>
                              </Select.Option>
                              {heroStatusSize.map((type) => {
                                return (
                                  <Select.Option
                                    key={type.heroStatus}
                                    value={type.heroStatus}>
                                    {type.heroStatus}&nbsp;
                                    <Tag color="#FF33D4">{type.size}</Tag>
                                  </Select.Option>
                                )
                              })}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item style={{ margin: 0 }} label="ประเภทฮีโร่">
                          {getFieldDecorator(`heroType`, {
                            initialValue: 'all'
                          })(
                            <Select style={{ width: 240 }}>
                              <Select.Option value="all">
                                ทั้งหมด &nbsp;
                                <Tag color="#BB33FF">
                                  {countAllHeroTypeSize()}
                                </Tag>
                              </Select.Option>
                              {heroTypeSize.map((type) => {
                                return (
                                  <Select.Option
                                    key={type.heroType}
                                    value={type.heroType}>
                                    {HeroType[type.heroType].title} &nbsp;
                                    <Tag color="#BB33FF">{type.size}</Tag>
                                  </Select.Option>
                                )
                              })}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col>
                        <Checkbox 
                        onChange={onChangeShowLOMA}
                        checked={showAppLOMA}
                        >
                          แสดงฮีโร่ที่ใช้งานหน้าร้าน
                        </Checkbox>
                      </Col>
                      <Col>
                        <Button type="primary" htmlType="submit">
                          ค้นหา
                        </Button>
                      </Col>
                      <Col>
                        <Button type="danger" onClick={() => onClear()}>
                          เคลียร์
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <span>
                    {hasSelected
                      ? `เลือก ${selectedRowKeys.length} รายการ`
                      : ''}
                  </span>
                  <Col style={{ marginLeft: 5 }}>
                    <Button
                      type="primary"
                      onClick={() => onClickNotification()}>
                      สร้างการแจ้งเตือน
                    </Button>
                  </Col>
                  <Col style={{ marginLeft: 5 }}>
                    <Button type="ghost" onClick={() => onClearSelect()}>
                      ล้างการเลือก
                    </Button>
                  </Col>
                </Row>
              </Form>
              <br></br>
              {!isEmpty(heroList) && (
                <Table
                  rowSelection={rowSelection}
                  bordered
                  loading={isLoading}
                  scroll={{ x: 1730 }}
                  rowKey={(record) => record.id}
                  dataSource={heroList.content}
                  columns={columns}
                  pagination={{
                    current: heroList.pageable.pageNumber + 1,
                    pageSize: heroList.size,
                    pageSizeOptions: ['10', '20', '50', '100', '400'],
                    showSizeChanger: true,
                    onShowSizeChange: onShowSizeChange,
                    onChange: onChange,
                    total: heroList.totalElements
                  }}
                />
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Heroes Map" key="2">
              <HeroLocations locations={locationList} />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={
                <div>
                  Document Pending &nbsp;
                  {countRenderIdPending() > 0 ? (
                    <Tag color="#f50"> {countRenderIdPending()}</Tag>
                  ) : (
                    ''
                  )}
                </div>
              }
              key="3">
              <HeroDocument />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Heroes Address" key="4">
              <HeroAddress />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Heroes Truck" key="5">
              <HeroTruck />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Heroes Bank Account" key="6">
              <HeroBankAccount />
            </Tabs.TabPane>
          </Tabs>
          <UpdateCoinAllHero
            visibleCoin={visibleCoin}
            onCloseModalCoin={onCloseModalCoin}
            onOkCoin={onOkCoin}
          />
          <QrCodeModal
            visible={visibleQR}
            onClose={onCloseViewQr}
            qrCodeData={qrCode}
          />
          <UpdateStatus
            visible={visibleStatus}
            onOk={onOkStatus}
            onCancel={onCloseModalStatus}
            formData={formData}
          />
          <LogContract
            visible={visibleLogContract}
            onCancel={onCloseModalLogContract}
            formData={formData}
          />
          <NotificationCenterModal
            visibleNotiCenter={visibleNotiCenter}
            onOkNotiCenter={onOkNotiCenter}
            onCloseNotiCenter={onCloseNotiCenter}
            selectedRowKeys={selectedRowKeys}
            onChangeRadio={onChangeRadio}
            value={value}
            isLoadingNoti={isLoadingNoti}
          />
        </Card>
      ) : (
        <HeroModal
          heroConfigs={heroConfigList}
          visible={visible}
          onClose={onClose}
          onOk={onOk}
          formData={formData}
          statusOptions={STATUS}
          heroTypeOptions={HERO_TYPE}
        />
      )}
    </div>
  )
}

const WrappedHeroes = Form.create({ name: 'Heroes' })(Heroes)
export default WrappedHeroes
